var exports = {
  "kL": "DiscoveryEmptyState.module__container___MER0d2",
  "Kk": "DiscoveryEmptyState.module__icon___MER0d2",
  "Qq": "DiscoveryEmptyState.module__text___MER0d2",
  "R_": "DiscoveryEmptyState.module__heading___MER0d2",
  "h_": "DiscoveryEmptyState.module__description___MER0d2",
};

module.exports = exports;
